import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { Outlet } from "react-router-dom";
import OverViewIcon from "../icons/OverViewIcon copy";
import { getKey } from "../helpers/sessionKey";
import WelcomeIcon from "../icons/WelcomeIcon";
export const shouldShowWelcome = getKey("shouldShowWelcome");
export const navigation: any = [
  {
    name: "Dashboard",
    href: "",
    icon: "",
    children: [
      ...(shouldShowWelcome === "true" || shouldShowWelcome === null
        ? [
            {
              name: "Welcome",
              href: "/website-builder",
              icon: WelcomeIcon,
              activeIcon: WelcomeIcon,
            },
            {
              name: "Overview",
              href: "/website-builder/overview",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]
        : [
            {
              name: "Overview",
              href: "/website-builder",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]),
    ],
  },
  {
    name: "Module To be named",
    href: "",
    icon: "",
    children: [
      {
        name: "Navigation",
        href: "/website-builder/navigation",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Pages",
        href: "/website-builder/pages",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Popup Modal",
        href: "/website-builder/popup-modal",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Components",
        href: "/website-builder/components",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Setting",
        href: "/website-builder/theme",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` h-full p-2 overflow-y-auto`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
